import { createApp } from 'vue'
import store from 'store'

import RelatedProduct from './RelatedProduct.vue'

const el = '.nti-component--related-product'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(RelatedProduct)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}